export const reportCarburetionTypes = {
  GET_REPORT_CARBURETION: 'GET_REPORT_CARBURETION',
  SET_REPORT_CARBURETION_FILTERS: 'SET_REPORT_CARBURETION_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};
